import { Pipe, PipeTransform } from "@angular/core";
import { CommonModule } from "@angular/common";

@Pipe({
    name: "iswError",
    standalone: false
})
export class IswErrorPipe implements PipeTransform {


  
  responseCode = [
    { Z81: "Invalid Card Details! Try again" },
    { "00": "Transaction Successful" },
    { T0: "Continue Transaction" },
    { XS1: "Payment Time Limit Exceeded! Try Again" },
    { Z1: "Transaction Error" },
    { Z5: "Payment already processed" },
    { T1: "OTP error.Try Again" },
    { X03: "Daily Transaction Limit Exceeded" },
    { "54": "Card has Expired" },
    { "55": "Incorrect Pin" },
    { "91": "Issuer or Switch Inoperative" },
    { "56": "Card Record Not Found" },
  ];

  transform(value: any): any {
    for (let i = 0; i < this.responseCode.length; i++) {
      if (value == Object.keys(this.responseCode[i])) {
        return Object.values(this.responseCode[i]).toString();
      }
    }
    return value;
  }
}
